import SvgIcon from '@material-ui/core/SvgIcon';

type AnalyzeIconProps = {
  fill?: string;
  stroke?: string;
  fontSize?: 'inherit' | 'medium' | 'default' | 'large' | 'small' | undefined;
};

export function AnalyzeIcon({ fontSize, fill, stroke }: AnalyzeIconProps) {
  return (
    <SvgIcon width="32" height="32" viewBox="0 0 32 32" fontSize={fontSize}>
      <path
        d="M22.875 13L21.625 10.25L18.875 9L21.625 7.75L22.875 5L24.125 7.75L26.875 9L24.125 10.25L22.875 13ZM22.875 27L21.625 24.25L18.875 23L21.625 21.75L22.875 19L24.125 21.75L26.875 23L24.125 24.25L22.875 27ZM12.875 24L10.375 18.5L4.875 16L10.375 13.5L12.875 8L15.375 13.5L20.875 16L15.375 18.5L12.875 24ZM12.875 19.15L13.875 17L16.025 16L13.875 15L12.875 12.85L11.875 15L9.725 16L11.875 17L12.875 19.15Z"
        fill={fill ?? 'currentColor'}
        stroke={stroke}
      />
    </SvgIcon>
  );
}
